var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.315 11.08a1.092 1.092 0 0 1 1.364 0l2.729 2.182a1.092 1.092 0 0 1-1.364 1.705l-.955-.764v7.552a1.092 1.092 0 0 1-2.183 0v-7.552l-.956.764a1.092 1.092 0 0 1-1.363-1.705l2.728-2.183z",
    fill: "#6363FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.077 1.116a7.095 7.095 0 0 1 7.845 4.288 6.55 6.55 0 1 1 .534 13.077 1.091 1.091 0 1 1-.002-2.183 4.366 4.366 0 1 0-1.006-8.615l-1.435.39a1.091 1.091 0 0 1-.574-2.106l.304-.083a4.912 4.912 0 0 0-9.269 2.742l.019.092c.018.083.044.2.08.33.078.286.172.535.255.667a1.092 1.092 0 0 1-1.85 1.159c-.12-.19-.218-.4-.299-.604a3.278 3.278 0 0 0-.394 5.202c.597.53 1.367.823 2.165.826h1.09a1.092 1.092 0 0 1 0 2.183H5.445A5.46 5.46 0 0 1 3.263 8.023a7.095 7.095 0 0 1 5.814-6.907z",
    fill: "#6363FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5d88c345cf498e5c61c4dd6a533a970d.svg";
export { ForwardRef as ReactComponent };